import { TableCell, TableRow } from "@material-ui/core";
import {
  createStyles,
  createTheme,
  Theme,
  withStyles,
} from "@material-ui/core/styles";

export const mainTheme = createTheme({
  palette: {
    primary: {
      main: "#292961",
    },
    secondary: {
      light: "#ff3f878",
      main: "#f0f757",
      dark: "#a8ac3c",
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    type: "dark",
  },
});

export const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

export const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
